import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NotificationSettingService } from "../../service/data/notification-setting";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NotificationKind, NotificationKindDescription, NotificationKindToString } from "../../model/const/enum";
import { finalize, Subscription } from "rxjs";
import { FormControlExFactory } from "../../../core/service/factory/form-control-ex-factory.service";
import { MessageService } from "../../../core/service/message.service";

type NotificationKindCheckboxItem = {
  key: string,
  value: number,
  label: string,
  description: string,
  icon: string
};

@Component({
    selector: 'app-notification-setting',
    templateUrl: './notification-setting.component.html',
    styleUrls: ['./notification-setting.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationSettingComponent implements OnInit, OnDestroy {
  constructor(
    private _service: NotificationSettingService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _messageService: MessageService
  ) {}

  private _subscriptions: Subscription;
  form: FormGroup;
  initialized: boolean = false;
  notificationKinds: NotificationKindCheckboxItem[];

  ngOnInit() {
    // Convert enum to labels/values
    this.notificationKinds = Object.keys(NotificationKind)
      .filter(key => isNaN(Number(key)))
      .map(key => {
        const enumValue = NotificationKind[key as keyof typeof NotificationKind];

        return {
          key,
          value: NotificationKind[key as keyof typeof NotificationKind],
          label: NotificationKindToString(enumValue),
          description: NotificationKindDescription(enumValue),
          icon: this._notificationKindIcon(enumValue)
        }
      });

    // Build form: one control per enum key (boolean)
    const group: any = {};
    this.notificationKinds.forEach(k => {
      group[k.key] = this._fcf.create(k.label, false); 
    });

    this.form = this._fb.group(group);

    // Load selections
    this._subscriptions = this._service.get()
      .pipe(finalize(() => this.initialized = true))
      .subscribe(selectedTypes => {
        this.notificationKinds.forEach(k => {
          this.form.controls[k.key].setValue(
            selectedTypes.includes(k.value)
          );
        });
      });
  }

  onSubmit() {
    // convert back to numeric enum values
    const result = Object.keys(this.form.value)
      .filter(key => this.form.value[key])   // only checked
      .map(key => NotificationKind[key]);

    this._service.change(result).subscribe(() => {
      this._messageService.showSuccess();
    })
  }

  ngOnDestroy(): void {
    this._subscriptions?.unsubscribe();
  }
  
  private _notificationKindIcon(source: NotificationKind) {
    switch (source) {
      case NotificationKind.FaultNotification:
        return 'fault-notification-i';
      case NotificationKind.Errand:
        return 'errand-i';
      default:
        return 'mail-i';
    }
  }
}